import validator from 'validator';

export const password = ({ password, password_confirm }) => {
  switch (true) {
    case (!validateLength(password)): return { password: PASSWORD_LENGTH };
    case (!validateMatch(password, password_confirm)): return { password: PASSWORD_MATCH };
    default: return;
  }
};

export const passwordConfirm = ({ password, password_confirm }) => {
  switch (true) {
    case (!validateLength(password_confirm)): return { password_confirm: PASSWORD_LENGTH };
    case (!validateMatch(password, password_confirm)): return { password_confirm: PASSWORD_MATCH };
    default: return;
  }
};

const PASSWORD_MATCH = `Your password and password confirmation must match`;
const PASSWORD_LENGTH = `Your password and password confirmation must be at least 8 charecters long`;

const validateLength = value => validator.isLength(value, { min: 8 });

const validateMatch = (password, confirm) => validator.equals(password, confirm);
